import { Suspense } from 'react'

export const withSuspense = (component, fallback = <></>) => <Suspense fallback={fallback}>{component}</Suspense>
